var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.295 1.954l-9.61 9.61a.563.563 0 00.796.797l9.61-9.61a4.566 4.566 0 116.458 6.457L8.3 18.456a3.284 3.284 0 01-4.643-4.644l9.248-9.248a2.002 2.002 0 012.83 2.83l-8.16 8.16a.563.563 0 10.796.796l8.16-8.16a3.127 3.127 0 00-4.422-4.422L2.86 13.015a4.41 4.41 0 006.236 6.236l9.248-9.247a5.692 5.692 0 00-8.05-8.05z",
    fill: "#575D9B",
    stroke: "#575D9B",
    strokeWidth: 0.1
  })));
};

export default SvgUpload;